export const STUDIO_APPROVED_ELEVENLABS_VOICE_CATALOG = [
  {
    id: "erin",
    label: "Erin",
    elevenLabsVoiceId: "DXFkLCBUTmvXpp2QwZjA",
    summary: "Warm, calm American female",
    bestUse:
      "Keep the Studio draft aligned with the current approved ElevenLabs default.",
    selectionScope: "current_live_default",
    selectionScopeLabel: "Approved Studio default",
    selectionScopeNote:
      "Erin is the current approved ElevenLabs default in Studio. Selecting Erin keeps the draft aligned with the approved handoff default while Preview continues to show current runtime truth.",
  },
  {
    id: "belle",
    label: "Belle",
    elevenLabsVoiceId: "cNYrMw9glwJZXR8RwbuR",
    summary: "Empathetic, warm, 9+ languages",
    bestUse:
      "Trust-first demos and multilingual walkthroughs that need a warmer bedside manner.",
    selectionScope: "draft_catalog_only",
    selectionScopeLabel: "Draft catalog choice",
    selectionScopeNote:
      "Studio records Belle in the draft and handoff package. Preview continues to show current runtime truth, and live inbound stays on the current delivery posture unless an operator applies a later approved change outside Studio.",
  },
  {
    id: "hope",
    label: "Hope",
    elevenLabsVoiceId: "WAhoMTNdLdMoq1j3wf3I",
    summary: "Smooth talker, 16+ languages",
    bestUse:
      "Polished multilingual reviews where the team wants a smoother concierge delivery.",
    selectionScope: "draft_catalog_only",
    selectionScopeLabel: "Draft catalog choice",
    selectionScopeNote:
      "Studio records Hope in the draft and handoff package. Preview continues to show current runtime truth, and live inbound stays on the current delivery posture unless an operator applies a later approved change outside Studio.",
  },
  {
    id: "kai",
    label: "Kai",
    elevenLabsVoiceId: "cauGUrZQIRUvQs3glrUi",
    summary: "Southern female",
    bestUse:
      "Regional or hospitality-led walkthroughs that benefit from a warmer southern cadence.",
    selectionScope: "draft_catalog_only",
    selectionScopeLabel: "Draft catalog choice",
    selectionScopeNote:
      "Studio records Kai in the draft and handoff package. Preview continues to show current runtime truth, and live inbound stays on the current delivery posture unless an operator applies a later approved change outside Studio.",
  },
  {
    id: "natalie",
    label: "Natalie",
    elevenLabsVoiceId: "KpTQ5yzwazQWLkvnK59A",
    summary: "Engaging female",
    bestUse:
      "High-energy demos that still need a professional, client-friendly female voice.",
    selectionScope: "draft_catalog_only",
    selectionScopeLabel: "Draft catalog choice",
    selectionScopeNote:
      "Studio records Natalie in the draft and handoff package. Preview continues to show current runtime truth, and live inbound stays on the current delivery posture unless an operator applies a later approved change outside Studio.",
  },
  {
    id: "claire",
    label: "Claire",
    elevenLabsVoiceId: "xYa75LlayhWHCRl1yJSH",
    summary: "Intimate, lispy, female",
    bestUse:
      "Soft-spoken walkthroughs where a more intimate female delivery is preferred for review.",
    selectionScope: "draft_catalog_only",
    selectionScopeLabel: "Draft catalog choice",
    selectionScopeNote:
      "Studio records Claire in the draft and handoff package. Preview continues to show current runtime truth, and live inbound stays on the current delivery posture unless an operator applies a later approved change outside Studio.",
  },
  {
    id: "lauren",
    label: "Lauren",
    elevenLabsVoiceId: "3liN8q8YoeB9Hk6AboKe",
    summary: "Commanding, female customer service",
    bestUse:
      "Clear operator walkthroughs that need firmer customer-service cadence and authority.",
    selectionScope: "draft_catalog_only",
    selectionScopeLabel: "Draft catalog choice",
    selectionScopeNote:
      "Studio records Lauren in the draft and handoff package. Preview continues to show current runtime truth, and live inbound stays on the current delivery posture unless an operator applies a later approved change outside Studio.",
  },
  {
    id: "ava",
    label: "Ava",
    elevenLabsVoiceId: "gJx1vCzNCD1EQHT212Ls",
    summary: "Clear, helpful female",
    bestUse:
      "Straightforward install-day walkthroughs where clarity matters more than personality.",
    selectionScope: "draft_catalog_only",
    selectionScopeLabel: "Draft catalog choice",
    selectionScopeNote:
      "Studio records Ava in the draft and handoff package. Preview continues to show current runtime truth, and live inbound stays on the current delivery posture unless an operator applies a later approved change outside Studio.",
  },
  {
    id: "eve",
    label: "Eve",
    elevenLabsVoiceId: "BZgkqPqms7Kj9ulSkVzn",
    summary: "Authentic, happy, energetic female",
    bestUse:
      "Livelier demos that still need to stay inside a controlled approved voice set.",
    selectionScope: "draft_catalog_only",
    selectionScopeLabel: "Draft catalog choice",
    selectionScopeNote:
      "Studio records Eve in the draft and handoff package. Preview continues to show current runtime truth, and live inbound stays on the current delivery posture unless an operator applies a later approved change outside Studio.",
  },
  {
    id: "professor",
    label: "Professor",
    elevenLabsVoiceId: "vdilQVOoXfeYFVrBjb5E",
    summary: "Deep timber, warm storytelling male",
    bestUse:
      "Founder or narrative-led demos that want a deeper, steadier male voice for review.",
    selectionScope: "draft_catalog_only",
    selectionScopeLabel: "Draft catalog choice",
    selectionScopeNote:
      "Studio records Professor in the draft and handoff package. Preview continues to show current runtime truth, and live inbound stays on the current delivery posture unless an operator applies a later approved change outside Studio.",
  },
] as const;

export type StudioApprovedElevenLabsVoiceCatalogEntry =
  (typeof STUDIO_APPROVED_ELEVENLABS_VOICE_CATALOG)[number];
export type StudioApprovedElevenLabsVoiceId =
  StudioApprovedElevenLabsVoiceCatalogEntry["id"];

export const STUDIO_DEFAULT_APPROVED_ELEVENLABS_VOICE_ID =
  STUDIO_APPROVED_ELEVENLABS_VOICE_CATALOG[0].id;

export function getStudioApprovedElevenLabsVoice(
  id: StudioApprovedElevenLabsVoiceId
) {
  return (
    STUDIO_APPROVED_ELEVENLABS_VOICE_CATALOG.find((voice) => voice.id === id) ||
    STUDIO_APPROVED_ELEVENLABS_VOICE_CATALOG[0]
  );
}

export function getStudioDefaultApprovedElevenLabsVoice() {
  return STUDIO_APPROVED_ELEVENLABS_VOICE_CATALOG[0];
}
